export default __webpack_public_path__ + "images/dfe2060313e4309c60e9ce08fd3e4532-Saudi_Riyal_Symbol.svg";